<template>
    <div class="row-fill container-col">
      <h1 class="row-fit">
        أهلًا {{ userName }}
      </h1>
      <div class="row-fill default-padding">
        <div v-if="stats === null || user === null" class="col-fill">
          <div class="loader"/>
        </div>
        <div v-else>
          <h2>
            آخر المتوارات التي شاهدتها 
          </h2>
          <div>
            <collocation v-for="c of recent_collocations_visited" :key="c.pattern + c.lempos"
              :lempos-string="c.lempos" :pattern="c.pattern" class="collocation" :class="c.css_class"/>
          </div>
          <h2>
            آخر المتوارات التي قيمتها 
          </h2>
          <div>
            <collocation v-for="c of recent_collocations_rated" :key="c.pattern + c.lempos"
              :lempos-string="c.lempos" :pattern="c.pattern" class="collocation" :class="c.css_class"/>
          </div>
          <p class="stats">
            بالمجمل قمت بتقييم
            <b> {{ stats.rated_colls_count }} </b>
            من المتواردات و
            <b>{{ stats.rated_examples_count }} </b>
            من الجمل. شكرًا!
          </p>
          <h2>
            آخر الكلمات التي قمت بتصنيف المتواردات لها 
          </h2>
          <ul>
            <li v-for="lempos of stats.recent_lemmas_grouped_colls">
              <router-link :to="{ name: 'lemma', params: {lempos} }">
                {{ lemposToLemma(lempos)}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>

import { auth } from '../components/user-management/firebase.js'
import { onIdTokenChanged } from 'firebase/auth'

import { api } from '../mixins/api.js'
import Collocation from '../components/Collocation.vue'

import { PATTERN_CLASSES } from '../lib/patters'

export default {
  name: 'UserHomeView',
  mixins: [api],
  components: { Collocation },
  data: function () {
    return {
      stats: null
    }
  },
  created: function () {
    this.loadUserStats()
    onIdTokenChanged(auth, this.loadUserStats)
  },
  methods: {
    loadUserStats: function () {
      if (!this.user) {
        return
      }
      var t = this
      this.getUserStats(this.user).then(function (response) {
        t.stats = response.data
      })
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user
    },
    userName: function () {
      if (this.user) {
        return this.user.displayName || this.user.email || this.user.phone
      } else {
        return null 
      }
    },
    recent_collocations_visited: function () {
      return this.stats.recent_collocations_visited.map(c => ({
        pattern: c.pattern, lempos: c.lempos, css_class: PATTERN_CLASSES[c.pattern]
      }))
    },
    recent_collocations_rated: function () {
      return this.stats.recent_collocations_rated.map(c => ({
        pattern: c.pattern, lempos: c.lempos, css_class: PATTERN_CLASSES[c.pattern]
      }))
    }
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
  padding-top: 65px;
}
h2 {
  padding-top: 20px;
  clear: both
}
.stats {
  color: darkgray;
  clear: both
}
.collocation {
    background-color: var(--bg-color);
}
</style>
